// removed by extract-text-webpack-plugin
module.exports = {"root":"_1U4FHCB","input":"_2aD0vT9","label":"_3Opt6K2","checkBox":"_2Xoy0y8","rootFocus":"_3sLE7h1","checkMark":"_1ER-0Cm"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/fields/Checkbox/Checkbox.less
 ** module id = 695
 ** module chunks = 0
 **/